import React, { Component } from "react";
import { Modal, Button, Text, Link } from "@shopify/polaris";

class UpgradeModal extends Component {
  render() {
    const { active, handleClose, chargeUrl } = this.props;
    console.log("charge id", chargeUrl);
    return (
      <Modal open={active} onClose={handleClose}>
        <Modal.Section>
          <Text variant="heading2xl" as="p">
            <span role="img" aria-label="speaker icon">
              📣
            </span>{" "}
            We recommend switching to Lit Discount in Cart
          </Text>
          <p style={{ margin: "30px 0" }}>
            Dcode is optimized for legacy stores built before 2021. For stores
            built after 2021, we recommend using{" "}
            <Link
              url="https://apps.shopify.com/discount-before-checkout"
              external
            >
              Lit Discount in Cart
            </Link>{" "}
            instead. It has all the features of Dcode, is faster and more
            reliable and comes with a permanent free plan.
            <br />
            If you need any help with the setup or migration, please contact us
            at <a href="mailto:dcode@lit.dog">dcode@lit.dog</a>.
          </p>
          <Button url={chargeUrl} external primary size="large" fullWidth>
            Upgrade for free
          </Button>
        </Modal.Section>
      </Modal>
    );
  }
}

export default UpgradeModal;
